import React from "react";
import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";
const SamsaraIntegration = lazyLoader(
  () =>
    import(
      "Containers/SamsaraIntegration/SamsaraIntegration/SamsaraIntegration"
    )
);

export const SamsaraIntegrationPage = () => {
  return (
    <Layout>
      <SamsaraIntegration />
    </Layout>
  );
};
